/* global show_8843260 */
import axios from "axios";
import { useEffect, useState } from "react";
import { API_URL } from "../config";
import { toast } from "react-toastify";
import ReactGA from "react-ga4";
import { FaGem } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export const ShowAdButton = (props) => {
  const [cooldown, setCooldown] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [adCount, setAdCount] = useState(0);

  const completedAd = () => {
    ReactGA.event({
      category: "Ad",
      action: "Ad watched",
      label: "Ad watched",
    });

    // Single atomic call — server checks cooldown + daily cap, then awards + saves state
    axios
      .post(
        `${API_URL}/api/user/${props.userId}/claimAdReward`,
        { initData: props.webApp },
        { headers: { "x-api-key": props.APIKey } }
      )
      .then((res) => {
        const { earnedPoints, adCount: newCount, adCooldown: cdExpiry, adExpiry } = res.data;

        props.onPointsUpdate(earnedPoints);

        // Mirror server state into localStorage so UI survives page refreshes
        localStorage.setItem("adCooldown", JSON.stringify({ expiry: cdExpiry }));
        localStorage.setItem("adCount", newCount);
        localStorage.setItem("adExpiry", JSON.stringify(new Date(adExpiry).getTime()));

        toast.success(`You have earned ${earnedPoints} points!`, {
          autoClose: 2000,
          position: "bottom-center",
          closeButton: false,
          pauseOnFocusLoss: false,
        });

        setAdCount(newCount);
        if (newCount >= 5) {
          // Daily limit hit — isDone takes over the UI, no need to run the countdown
          setCooldown(false);
        } else {
          setCooldown(true);
          setTimeLeft(Math.ceil((cdExpiry - Date.now()) / 1000));
        }
      })
      .catch((err) => {
        const serverMsg = err.response?.data?.error;
        const secondsLeft = err.response?.data?.secondsLeft;

        if (err.response?.status === 429) {
          if (secondsLeft) {
            // Cooldown still active — sync local timer to server truth
            setCooldown(true);
            setTimeLeft(secondsLeft);
            toast.error("အချိန်ပြည့်အောင်စောင့်ပါ။", {
              autoClose: 2000,
              position: "bottom-center",
              closeButton: false,
              pauseOnFocusLoss: false,
            });
          } else {
            // Daily limit
            toast.error("ကြော်ငြာ ၅ ခု ပြည့်ပါပြီ။", {
              autoClose: 2000,
              position: "bottom-center",
              closeButton: false,
              pauseOnFocusLoss: false,
            });
          }
        } else {
          console.error("Error claiming ad reward:", err);
          toast.error("Something went wrong. Please try again.", {
            autoClose: 2000,
            position: "bottom-center",
          });
        }
      });
  };

  useEffect(() => {
    // Effect function
    if (window.show_8843260) {
      return;
    }
  }, []);

  useEffect(() => {
    // Effect function
    // if (window.show_8843260) {
    //   return;
    // }

    // const tag = document.createElement("script");

    // tag.src = "//doodiwom.com/vignette.min.js";
    // tag.dataset.zone = "8843260";
    // tag.dataset.sdk = "show_8843260";

    // document.body.appendChild(tag);

    axios
      .get(`${API_URL}/api/user/${props.userId}`, {
        params: { initData: props.webApp },
        headers: { "x-api-key": props.APIKey },
      })
      .then((res) => {
        const { adCooldown, adCount, adExpiry } = res.data;
        if (adCooldown) {
          const remainingTime = new Date(adCooldown).getTime() - Date.now();
          if (remainingTime > 0) {
            setCooldown(true);
            setTimeLeft(Math.floor(remainingTime / 1000));
            localStorage.setItem(
              "adCooldown",
              JSON.stringify({ expiry: adCooldown })
            );
          } else {
            localStorage.removeItem("adCooldown");
          }
        }

        if (adCount && adExpiry) {
          if (Date.now() < new Date(adExpiry).getTime()) {
            setAdCount(adCount);
            localStorage.setItem("adCount", adCount);
            localStorage.setItem("adExpiry", JSON.stringify(adExpiry));
          } else {
            localStorage.removeItem("adCount");
            localStorage.removeItem("adExpiry");
          }
        }
      })
      .catch((err) => {
        console.error("Error retrieving ad data from MongoDB:", err);
      });

    const savedCooldown = localStorage.getItem("adCooldown");
    const savedAdCount = localStorage.getItem("adCount");
    const savedAdExpiry = localStorage.getItem("adExpiry");

    if (savedCooldown) {
      const cooldownData = JSON.parse(savedCooldown);
      const remainingTime = cooldownData.expiry - Date.now();
      if (remainingTime > 0) {
        setCooldown(true);
        setTimeLeft(Math.floor(remainingTime / 1000));
      } else {
        localStorage.removeItem("adCooldown");
      }
    }

    if (savedAdCount && savedAdExpiry) {
      const adExpiry = JSON.parse(savedAdExpiry);
      if (Date.now() < adExpiry) {
        setAdCount(parseInt(savedAdCount, 10));
      } else {
        localStorage.removeItem("adCount");
        localStorage.removeItem("adExpiry");
      }
    }
  }, []);

  useEffect(() => {
    let timer;
    if (cooldown) {
      timer = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setCooldown(false);
            localStorage.removeItem("adCooldown");
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [cooldown]);
  const showAd = () => {
    ReactGA.event({
      category: "Ad",
      action: "Ad button clicked",
      label: "Ad button clicked",
    });
    if (adCount >= 5) {
      toast.error("ကြော်ငြာ ၅ ခု ပြည့်ပါပြီ။", {
        autoClose: 2000,
        position: "bottom-center",
        closeButton: false,
        pauseOnFocusLoss: false,
      });
      return;
    }

    if (cooldown) {
      toast.error("အချိန်ပြည့်အောင်စောင့်ပါ။", {
        autoClose: 2000,
        position: "bottom-center",
        closeButton: false,
        pauseOnFocusLoss: false,
      });
      return;
    }
    if (typeof show_8843260 === "function") {
      show_8843260().then(() => {
        completedAd();
      }).catch((e) => {
        console.error("Ad failed:", e);
      });
    } else if (typeof window.show_8843260 === "function") {
      window.show_8843260().then(() => {
        completedAd();
      }).catch((e) => {
        console.error("Ad failed:", e);
      });
    } else {
      toast.error("Ads are currently unavailable.", {
        autoClose: 2000,
        position: "bottom-center",
        closeButton: false,
        pauseOnFocusLoss: false,
      });
    }
  };

  const progressPct = Math.min((adCount / 5) * 100, 100);
  const isDone = adCount >= 5;

  return (
    <div className="rounded-2xl my-2 shadow-sm border-2 border-fuchsia-200 dark:border-fuchsia-700/50 overflow-hidden bg-white dark:bg-slate-900 transition-colors duration-300">
      {/* Top accent stripe */}
      <div className="h-1 bg-gradient-to-r from-fuchsia-500 via-purple-500 to-indigo-500" />

      <div className="flex justify-between items-start p-4">
        {/* Left */}
        <div className="flex-grow mr-4">
          <h3 className="text-slate-900 dark:text-white font-semibold">Watch Ads</h3>
          <p className="text-slate-500 dark:text-slate-400 text-sm mt-0.5">Earn gems by watching short ads</p>

          {/* Reward pill */}
          <div className="flex items-center gap-2 mt-2">
            <span className="inline-flex items-center gap-1 bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 text-xs font-semibold px-2 py-0.5 rounded-full">
              <FaGem size={10} className="inline mr-1" /> 10 per ad
            </span>
          </div>

          {/* Progress bar */}
          <div className="mt-3">
            <div className="flex justify-between text-xs text-slate-500 dark:text-slate-400 mb-1">
              <span>Ads watched today</span>
              <span className="font-semibold text-slate-700 dark:text-slate-200">{adCount}/5</span>
            </div>
            <div className="h-1.5 w-full bg-slate-200 dark:bg-slate-700 rounded-full overflow-hidden">
              <div
                className="h-full bg-gradient-to-r from-fuchsia-500 to-purple-500 rounded-full transition-all duration-500"
                style={{ width: `${progressPct}%` }}
              />
            </div>
          </div>

          {/* Daily limit reached */}
          {isDone && (
            <p className="text-xs text-slate-400 dark:text-slate-500 mt-2">
              Daily limit reached. Resets in {String(Math.floor(
                (new Date(JSON.parse(localStorage.getItem("adExpiry") || "0")).getTime() - Date.now()) / 3600000
              )).padStart(2, "0")}h
            </p>
          )}
        </div>

        {/* Right — button */}
        <div className="flex-shrink-0">
          <button
            className={`text-sm px-3 py-2 rounded-md text-white w-20 text-center block transition-colors ${
              isDone
                ? "bg-gray-500 opacity-50 cursor-not-allowed"
                : cooldown
                ? "bg-amber-500 cursor-not-allowed"
                : "bg-fuchsia-500 hover:bg-fuchsia-600"
            }`}
            onClick={showAd}
            disabled={isDone || cooldown}
          >
            {isDone
              ? "Done"
              : cooldown
              ? `${String(Math.floor(timeLeft / 60)).padStart(2, "0")}:${String(timeLeft % 60).padStart(2, "0")}`
              : "Watch"}
          </button>
        </div>
      </div>
    </div>
  );
};

export const ShowFootballAdButton = (props) => {
  const [adCount, setAdCount] = useState(0);
  const [isProcessing, setIsProcessing] = useState(false);

  const completedAd = () => {
    ReactGA.event({
      category: "Ad",
      action: "Football Ad watched",
    });

    axios
      .post(
        `${API_URL}/api/user/${props.userId}/claimFootballAdReward`,
        { initData: props.webApp },
        { headers: { "x-api-key": props.APIKey } }
      )
      .then((res) => {
        const { earnedPoints, adCount: newCount, adExpiry } = res.data;
        props.onPointsUpdate(earnedPoints);

        localStorage.setItem("footballAdCount", newCount);
        localStorage.setItem("footballAdExpiry", JSON.stringify(new Date(adExpiry).getTime()));

        toast.success(`You have earned ${earnedPoints} gems!`, { autoClose: 2000, position: "bottom-center" });
        setAdCount(newCount);
      })
      .catch((err) => {
        if (err.response?.status === 429) {
          toast.error("ကြော်ငြာ ၅ ခု ပြည့်ပါပြီ။", { autoClose: 2000, position: "bottom-center" });
        } else {
          toast.error("Something went wrong.", { autoClose: 2000, position: "bottom-center" });
        }
      })
      .finally(() => setIsProcessing(false));
  };

  useEffect(() => {
    axios
      .get(`${API_URL}/api/user/${props.userId}`, {
        params: { initData: props.webApp },
        headers: { "x-api-key": props.APIKey },
      })
      .then((res) => {
        const { footballAdCount, footballAdExpiry } = res.data;
        if (footballAdCount && footballAdExpiry) {
          if (Date.now() < new Date(footballAdExpiry).getTime()) {
            setAdCount(footballAdCount);
            localStorage.setItem("footballAdCount", footballAdCount);
            localStorage.setItem("footballAdExpiry", JSON.stringify(footballAdExpiry));
          } else {
            localStorage.removeItem("footballAdCount");
            localStorage.removeItem("footballAdExpiry");
          }
        }
      });
  }, []);

  const showAd = () => {
    if (adCount >= 5) {
      toast.error("ကြော်ငြာ ၅ ခု ပြည့်ပါပြီ။", { autoClose: 2000, position: "bottom-center" });
      return;
    }

    setIsProcessing(true);
    if (typeof show_8843260 === "function") {
      show_8843260().then(() => completedAd()).catch(() => setIsProcessing(false));
    } else if (typeof window.show_8843260 === "function") {
      window.show_8843260().then(() => completedAd()).catch(() => setIsProcessing(false));
    } else {
      toast.error("Ads are currently unavailable.");
      setIsProcessing(false);
    }
  };

  const progressPct = Math.min((adCount / 5) * 100, 100);
  const isDone = adCount >= 5;
  const navigate = useNavigate();

  if (isDone) {
    return (
      <div className="rounded-2xl my-2 shadow-sm border-2 border-amber-200 dark:border-amber-700/50 overflow-hidden bg-white dark:bg-slate-900 transition-colors duration-300">
        <div className="h-1 bg-gradient-to-r from-amber-500 to-orange-500" />
        <div className="p-4">
          <h3 className="text-slate-900 dark:text-white font-semibold">Need more gems?</h3>
          <p className="text-slate-500 dark:text-slate-400 text-sm mt-0.5 mb-3">Complete daily tasks or visit the store to get more!</p>
          <div className="flex gap-2">
            <button
              onClick={() => navigate('/tasks')}
              className="flex-1 text-sm px-3 py-2 rounded-md text-amber-700 bg-amber-100 hover:bg-amber-200 dark:bg-amber-900/40 dark:text-amber-300 dark:hover:bg-amber-900/60 transition-colors font-semibold"
            >
              Finish Tasks
            </button>
            <button
              onClick={() => navigate('/store')}
              className="flex-1 text-sm px-3 py-2 rounded-md text-white bg-amber-500 hover:bg-amber-600 transition-colors font-semibold shadow-sm"
            >
              Buy Gems
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-2xl my-2 shadow-sm border-2 border-emerald-200 dark:border-emerald-700/50 overflow-hidden bg-white dark:bg-slate-900 transition-colors duration-300">
      <div className="h-1 bg-gradient-to-r from-emerald-500 to-green-500" />
      <div className="flex justify-between items-start p-4">
        <div className="flex-grow mr-4">
          <h3 className="text-slate-900 dark:text-white font-semibold">Watch Ads</h3>
          <p className="text-slate-500 dark:text-slate-400 text-sm mt-0.5">Earn gems by watching short ads</p>
          <div className="flex items-center gap-2 mt-2">
            <span className="inline-flex items-center gap-1 bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 text-xs font-semibold px-2 py-0.5 rounded-full">
              <FaGem size={10} className="inline mr-1" /> 10 per ad
            </span>
          </div>
          <div className="mt-3">
            <div className="flex justify-between text-xs text-slate-500 dark:text-slate-400 mb-1">
              <span>Ads watched today</span>
              <span className="font-semibold text-slate-700 dark:text-slate-200">{adCount}/5</span>
            </div>
            <div className="h-1.5 w-full bg-slate-200 dark:bg-slate-700 rounded-full overflow-hidden">
              <div className="h-full bg-gradient-to-r from-emerald-500 to-green-500 rounded-full transition-all duration-500" style={{ width: `${progressPct}%` }} />
            </div>
          </div>
        </div>
        <div className="flex-shrink-0">
          <button
            className={`text-sm px-3 py-2 rounded-md text-white w-20 text-center block transition-colors ${
              isProcessing ? "bg-gray-500 opacity-50 cursor-not-allowed" : "bg-emerald-500 hover:bg-emerald-600"
            }`}
            onClick={showAd}
            disabled={isProcessing}
          >
            Watch
          </button>
        </div>
      </div>
    </div>
  );
};
